var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7517 3.92335L5.47948 11.1933C5.34726 11.3255 5.21504 11.3916 5.0167 11.3916C4.81837 11.3916 4.68615 11.3255 4.55393 11.1933L1.24838 7.88879C0.983938 7.62443 0.983938 7.22789 1.24838 6.96352C1.51283 6.69916 1.90949 6.69916 2.17393 6.96352L5.0167 9.80543L11.8261 2.99808C12.0906 2.73371 12.4872 2.73371 12.7517 2.99808C13.0161 3.26244 13.0161 3.65898 12.7517 3.92335Z",
    fill: "#774EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPrimary);
export default __webpack_public_path__ + "static/media/check_primary.9b8cdfda58cd4acc2d3e8af54e5dfb33.svg";
export { ForwardRef as ReactComponent };